import { Module, StatusPanelDef } from '@ag-grid-community/core'
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core'
import { StatusBarModule } from '@ag-grid-enterprise/status-bar'
import { HttpStatusStatusBar } from './http-status-status-bar'
import { HttpDurationStatusBar } from './http-duration-status-bar'
import { HttpSizeStatusBar } from './http-size-status-bar'

export const devToolsHttpStatusBarModuleName =
  'hsDevToolsHttpStatusBarModuleName'
export const hsHttpStatusStatusBar = 'hsHttpStatusStatusBar'
export const hsHttpDurationStatusBar = 'hsHttpDurationStatusBar'
export const hsHttpSizeStatusBar = 'hsHttpSizeStatusBar'

export const devToolsHttpStatusBarPanel: { statusPanels: StatusPanelDef[] } = {
  statusPanels: [
    {
      statusPanel: hsHttpStatusStatusBar,
      align: 'left',
    },
    {
      statusPanel: hsHttpDurationStatusBar,
      align: 'center',
    },
    {
      statusPanel: hsHttpSizeStatusBar,
      align: 'right',
    },
  ],
}

export const DevToolsHttpStatusBarModule: Module = {
  moduleName: devToolsHttpStatusBarModuleName,
  userComponents: [
    {
      componentName: hsHttpStatusStatusBar,
      componentClass: HttpStatusStatusBar,
    },
    {
      componentName: hsHttpDurationStatusBar,
      componentClass: HttpDurationStatusBar,
    },
    {
      componentName: hsHttpSizeStatusBar,
      componentClass: HttpSizeStatusBar,
    },
  ],
  dependantModules: [StatusBarModule, EnterpriseCoreModule],
}
